export const photoUploaderContext = React.createContext()